export default __webpack_public_path__ + "static/media/05.e3df3070.jpg";